export const AI = {
  VIEWSTATE_aiops_dashboard: 'VIEWSTATE_aiops_dashboard',

  GRIDCOLUMNS_aiops_insightDetail_similarHistoryList:
    'GRIDCOLUMNS_aiops_insightDetail_similarHistoryList',
  FILTERSEARCH_aiops_insightDetail_similarHistoryList:
    'FILTERSEARCH_aiops_insightDetail_similarHistoryList',
} as const;
